import { api } from '../core';
import { TOOLKIT_TAG } from '../constants';

export interface DeleteUserToolkitToolRequest {
  globalAdminAsUser?: string;
  toolId: string;
}

const deleteUserToolkitToolApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteUserToolkitTool: builder.mutation<void, DeleteUserToolkitToolRequest>({
      query: (body) => ({
        url: `toolkit/delete-user-tool`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [TOOLKIT_TAG],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useDeleteUserToolkitToolMutation } = deleteUserToolkitToolApi;
